import React from "react";
import { ShoppingCart } from "lucide-react";
import { ChartPanel } from "components/charts";
import { useTranslation } from "react-i18next";
import { SourceChip } from "../SourceChip";

export const AmazonSalesChartPanel = ({
  titleBadge,
  actions,
  legend,
  footer,
  subtitle,
  className,
  children,
}: {
  titleBadge?: React.ReactNode;
  actions?: React.ReactNode;
  legend?: React.ReactNode;
  footer?: React.ReactNode;
  subtitle?: React.ReactNode;
  className?: string;
  children?: React.ReactNode;
}) => {
  const { t } = useTranslation(["productDetails"]);
  return (
    <ChartPanel
      testId="amazon-sales-chart"
      icon={<ShoppingCart className="h-4 w-4" />}
      title={t("productDetails:salesData.amazonSales.title")}
      titleBadge={
        <>
          <SourceChip source="amazon" />
          {titleBadge}
        </>
      }
      subtitle={subtitle}
      actions={actions}
      legend={legend}
      footer={footer}
      className={className}
    >
      {children}
    </ChartPanel>
  );
};
